<template>
    <div>
     <div >
      <nav class="w-52 bg-white fixed left-0 top-0  min-h-screen  shadow-md">
      <div class="px-3 pt-2 logoclr">
         <img :src="'/imgs/tallyLogo4.png'" class="pb-1 " alt=""  aria-hidden="false"  >
         <hr>
      </div>
      <!-- <h6 class=" mt-1 pl-4 text-gray-400 font-bold">Menu</h6> -->
      <DxScrollView
        id="scrollview"
        ref="scrollViewWidget"
        :scroll-by-content="scrollByContent"
        :scroll-by-thumb="scrollByThumb"
        :show-scrollbar="showScrollbar"
        :bounce-enabled="pullDown"
        reach-bottom-text="Updating..."
      >
      <ul class="flex flex-col items-center mt-2 ">
      <jet-responsive-nav-link   :active="route().current('tallyclinic.index')" :href="'/login'" class=" w-full text-gray-400 ">
                  <i class="fas fa-th mr-3"></i>
                <span class="link-label">Dashboard</span>
      </jet-responsive-nav-link>
      <!-- :href="'/integrate?is_license_valid='+is_valid_license+'&is_electron='+is_electron+'&license_from_database='+license_no" -->
      <jet-responsive-nav-link  :active="route().current('tc-integrates')"  :href="'/tc-integrates'" class=" w-full text-gray-400 ">
        <i class="fas fa-signal mr-3"></i>
          <span class="link-label">Integrate</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link  href="#"  class=" w-full text-gray-400 ">
                <i class="fas fa-tools mr-3"></i>
                <span class="link-label">Manage</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link  href="#"  class="block w-full text-gray-400 ">
              <i class="fas fa-tasks mr-3"></i>
              <span class="link-label">Print</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link  href="#"  class=" w-full text-gray-400 ">
              <i class="fas fa-users mr-3"></i>
              <span class="link-label">Report</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link  href="#"  class=" w-full text-gray-400">
                <i class="fas fa-chart-line mr-3"></i>
                <span class="link-label">Analyse</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link   href="#"  class=" w-full  text-gray-400 ">
                <i class="fas fa-sync mr-3"></i>
                <span class="link-label">Sync</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link   href="#"  class="w-full text-gray-400 ">
                <i class="fas fa-comments mr-3"></i>
                <span class="link-label">Tally-on-Cloud</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link  href="#" class=" w-full text-gray-400 ">
                <i class="fas fa-puzzle-piece mr-3"></i>
                <span class="link-label">Add-Ons</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link  href="#"  class="w-full  text-gray-400 ">
                <i class="fas fa-cubes mr-3"></i>
                <span class="link-label">Modules</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link href="#" class="w-full  text-gray-400 ">
                <i class="fas fa-cogs mr-3"></i>
                <span class="link-label">Services</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link  href="#"  class=" w-full text-gray-400 ">
                <i class="fas fa-user-astronaut mr-3"></i>
                <span class="link-label">Trainings</span>
      </jet-responsive-nav-link>
      <!--  -->
      <jet-responsive-nav-link href="#" class=" w-full text-gray-400">
                <i class="fas fa-handshake mr-3"></i>
                <span class="link-label">Webinars</span>
      </jet-responsive-nav-link>
      <!--  -->
    </ul>

              </DxScrollView>
      </nav>
     </div>
      <!-- header -->
       <header class=" flex justify-between">
          <!-- <a href="#">Dashboard</a> -->
          <div>
          <h3 class="font-bold mt-0 "><slot name="headerTitle" v-if="$slots.headerTitle"></slot></h3>
        <!--   <button>click this</button> -->
          </div>

          <div>
            <!-- dropdown start from here -->
      
        <!-- Primary Navigation Menu -->
        <div class="max-w-7xl mx-auto px-0 sm:px-6 lg:px-8">
          <div class="flex justify-between ">
            <div class="flex">
              <!-- Logo -->
              <div class="flex-shrink-0 flex items-center">
                <Link >
                  <jet-application-mark class="block h-9 w-auto" />
                </Link>
              </div>
            </div>

            <div class="hidden sm:flex sm:items-center sm:ml-6">
              <div class="ml-3 relative">
                <!-- Teams Dropdown -->
                <jet-dropdown
                  align="right"
                  width="60"
                  v-if="$page.props.jetstream.hasTeamFeatures"
                >
                  <template #trigger>
                    <span class="inline-flex rounded-md">
                      <button
                        type="button"
                        class="
                          inline-flex
                          items-center
                          px-3
                          py-2
                          border border-transparent
                          text-sm
                          leading-4
                          font-medium
                          rounded-md
                          text-gray-500
                          bg-white
                          hover:bg-gray-50 hover:text-gray-700
                          focus:outline-none focus:bg-gray-50
                          active:bg-gray-50
                          transition
                        "
                      >
                        <!-- {{ $page.props.user.current_team.name }} -->
                          Select Tenant
                        <svg
                          class="ml-2 -mr-0.5 h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </span>
                  </template>

                  <template #content >
                    <div class="w-48 ">
                      <!-- Team Management -->
                      <template v-if="$page.props.jetstream.hasTeamFeatures">
                        <div class="block px-4 py-2 text-xs text-gray-400">
                          Admin
                        </div>

                        <!-- Tenant Admin Settings -->

                        <!-- Team Settings -->
                        <jet-dropdown-link
                          :href="route('tenant-admin-panels.users','admin')"
                        >
                          Tenant Admin Settings
                        </jet-dropdown-link>

                        <div class="border-t border-gray-100"></div>

                        <div class="block px-4 py-2 text-xs text-gray-400">
                          Manage Team
                        </div>

                        <!-- Team Settings -->
                        <jet-dropdown-link
                          :href="
                            route('teams.show', $page.props.user.current_team)
                          "
                        >
                          Team Settings
                        </jet-dropdown-link>

                       

                       
                      </template>
                    </div>
                  </template>
                </jet-dropdown>
              </div>
             
              <!-- &nbsp;  &nbsp; &nbsp;
              <div>
                     <i class="fas fa-cog"></i>
              </div>  -->
              
              &nbsp; &nbsp;
               <div>
              <i class="fas fa-bell"></i>   
                </div>
                &nbsp;  &nbsp; &nbsp;
               <div>
             <i class="fas fa-headset"></i>
                </div>
                 &nbsp;  
                 <jet-nav-icon  :active="route().current('tallyclinicconfigurations.index')" :href="'/configurations'" >
                  <i class="fas fa-cog "></i>
                </jet-nav-icon>

              <!-- Settings Dropdown -->
             <div class="ml-3 relative ">
                <jet-dropdown align="right" width="48">
                  <template #trigger>
                    <button
                      v-if="$page.props.jetstream.managesProfilePhotos"
                      class="
                        flex
                        text-sm
                        border-2 border-transparent
                        rounded-full
                        focus:outline-none focus:border-gray-300
                        transition
                      "
                    >
                      <img
                        class="h-8 w-8 rounded-full object-cover"
                        :src="$page.props.user.profile_photo_url"
                        :alt="$page.props.user.name"
                      />
                    </button>

                    <span v-else class="inline-flex rounded-md">
                      <button
                        type="button"
                        class="
                          inline-flex
                          items-center
                         
                          text-sm
                          leading-4
                          font-medium
                          rounded-md
                          text-gray-500
                          bg-white
                          hover:text-gray-700
                          focus:outline-none
                          transition
                        "
                      >
                        <!-- {{ $page.props.user.name }} -->
                       
                      <i class="fas fa-user-circle  text-2xl"></i>
                       
                        
                       
                      </button>
                    </span>
                  </template>

                  <template #content>
                    <!-- Account Management -->
                    <div class="block px-4 py-2 text-xs text-gray-400">
                      Manage Account
                    </div>

                   
                    <div class="border-t border-gray-100"></div>

                    <!-- Authentication -->
                    <form @submit.prevent="logout">
                      <jet-dropdown-link as="button">
                        Log Out
                      </jet-dropdown-link>
                    </form>
                  </template>
                </jet-dropdown>
              </div>
            </div>

            <!-- Hamburger -->
            <div class="-mr-2 flex items-center sm:hidden">
              <button
                @click="showingNavigationDropdown = !showingNavigationDropdown"
                class="
                  inline-flex
                  items-center
                  justify-center
                  p-2
                  rounded-md
                  text-gray-400
                  hover:text-gray-500 hover:bg-gray-100
                  focus:outline-none focus:bg-gray-100 focus:text-gray-500
                  transition
                "
              >
                <svg
                  class="h-6 w-6"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    :class="{
                      hidden: showingNavigationDropdown,
                      'inline-flex': !showingNavigationDropdown,
                    }"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                  <path
                    :class="{
                      hidden: !showingNavigationDropdown,
                      'inline-flex': showingNavigationDropdown,
                    }"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>


       <!-- dropdown end -->
            </div>
      
      </header>
     <!-- NavBar -->
      <nav-bar>
          <slot name="headerNav" v-if="$slots.headerNav"></slot>
      </nav-bar>

      <div class="main-content">
           <slot></slot>
      </div>
    </div>
</template>
<script>
import TcSettingsMenu from '@include/pages/BaseLayouts/tallyClinicSettingsMenu.vue';
import JetApplicationMark from "@/Jetstream/ApplicationMark.vue";
import JetDropdown from "@/Jetstream/Dropdown.vue";
import { DxScrollView } from 'devextreme-vue/scroll-view';
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import JetNavIcon from "@/Jetstream/NavIcon.vue";
import JetNavLink from '@/Jetstream/NavLink.vue';
import NavBar from './TallyClinicTopNavbar.vue';
import JetDropdownLink from '@/Jetstream/DropdownLink.vue';
// import {isElectron,checkTallyIsOpenElectron} from "../modules/UtilsJs/utils.js";
export default {
  components:{
    TcSettingsMenu,
    JetApplicationMark,
    JetDropdown,
    JetNavLink,
    JetDropdownLink,
    JetNavIcon,
    NavBar,
    JetResponsiveNavLink,
    DxScrollView
  },
  data:function(){
    return{
      tally_open_status:'false',
      pullDown: false,
      showScrollbar: 'onScroll',
      scrollByContent: true,
      scrollByThumb: true,
    }
  },
  methods:{
        checkTallyStatus(){
            var _this = this;
            checkTallyIsOpenElectron(_this);
        },
        logout(){
            this.$inertia.post(route('logout'));
        },
        reload_in_electron(){
            //check if tally is open 
            if(isElectron()){
                window.api.send('refresh_page'); 
                window.api.receive("refresh_page-reply", (tally_response) => {
                })
            }
        }
  },
  mounted(){
    
        $('li').on('click',function(){
        var a_links = $(this).find('a');
        $('a').removeClass('active');
        a_links.addClass('active');
        var _this = this;
        checkTallyIsOpenElectron(_this);
        
        })
        
},
}
</script>
<style scoped>
/* body {
  min-height: 100vh;
  background-color: #f3f4f6;
  padding: 0px;
} */

html{
  font-family:Rubik !important;
}
a.active {
  color:#10b981;
  font-weight: 300;
   /* background: #abffe3; */
}
 a .link.active::after {
  content: "";
  height: 100%;
  position: absolute;
  left: 205px;
  top: 0;
  width: 4px;
  background-color: #10b981;
}
a:hover{
  /* background-color: #10b981; */
  color: #10b981;
  text-decoration: none;
}
nav{
  transition:all .2s;
  /* border: 2px solid rgb(233, 233, 233); */
}

nav.expanded .link-label {
  display: none;
}
nav.expanded {
  width: 66px;
}
nav.expanded ul li{
  align-items: center;
  justify-content: center;
}
nav.expanded ul li a{
  align-items: center;
  justify-content: center;
}
nav.expanded ul li a svg{
 margin: 0;
}

/* header page */
header{
  /* overflow: hidden; */
  position: fixed; /* Set the navbar to fixed position */
  top: 0; 
  padding:4px 43px;
  width: 86.1%;
  display:flex;
  justify-content:space-between;
  background:white;
  border-bottom: 1px solid rgb(241, 240, 240);
 	margin-left: 210px;
   z-index: 2;
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  header{
width: 76%;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  header{
width: 82%;
  }
}

@media only screen and (min-width: 1280px) {
  header{
width: 86.1%;
  }
}

.nav-list{
  display:flex;
  flex-flow : row-reverse wrap;
  justify-content: space-around;
  align-items: center;
}
.nav-list li{
  display:inline-block;
  padding:10px;
  margin: 4px;
  width:auto;
  border-radius: 10px;
}
.nav-list a{
  color: rgb(150, 145, 145);
}
.logoclr{
  background-color: #07528E;
}
#scrollview {
  height: 80%;
  position: absolute;
  top: 90px;
  bottom: 10px;
  padding: 1px;
  width: 100%;
}
h3{
  margin-bottom: 0.1rem;
}
</style>